// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-cookie-policy>h2{font-size:var(--fs-600);margin-bottom:calc(var(--fs-700)*1.5)}.c-cookie-policy>h3{font-size:var(--fs-500);margin-bottom:var(--fs-700)}.c-cookie-policy>p{font-size:var(--fs-400)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
